(function ($, undefined) {
	"use strict";

	let frNote;
	let enNote;
	let field1;
	let field2;
	let field3;
	let toast;
	let model;

	function init() {
		let utils = Fw.component.models().utils;
		toast = Fw.component.models().toast;
		field1 = $('[name="field1"]');
		field2 = $('[name="field2"]');
		field3 = $('[name="field3"]');
		model = $('.fetch-model');
		frNote = document.getElementById('frNotes');
		enNote = document.getElementById('enNotes');
		$('#frNotes,#enNotes').on('keyup', utils.debounce(updateField3, 200));
		$('#add-inclusion, #add-exclusion').on('click', addInclusionExclusion);
		$('#event-inclusions').on('keyup', 'input, textarea', utils.debounce(buildField1, 200));
		$('#event-exclusions').on('keyup', 'input, textarea', utils.debounce(buildField2, 200));
		$('#event-inclusions,#event-exclusions').on('click', '.event-admin-inclusion-exclusion__delete', deleteInclusionExclusion);
		$('.eventAttendType').on('change', toggleLinkedEventPrices);
		$('.activity-type').on('change', toggleActivityEmailFields);
        model.on('click', fetchModel);

		if (location.search.indexOf("eventCreated") !== -1) {
			toast.create(
				document.documentElement.lang === 'fr' ? 'Votre événement a bien été créé!' : 'Your event was created successfully!',
				toast.DURATION.LONG,
				"success"
			);
		}

		if (location.search.indexOf("eventModified") !== -1) {
			toast.create(
				document.documentElement.lang === 'fr' ? 'Votre événement a bien été modifié!' : 'Your event was modified successfully!',
				toast.DURATION.LONG,
				"success"
			);
		}
	}

	function toggleActivityEmailFields() {
		var val = $(this).val();
		var isSymposium = val === '5';
		var isRDV = val === '6';
		var attendType = $('.eventAttendType').val();

		if (isSymposium || isRDV) {
			$('#emailExtraFields').removeClass('field_hidden');
			$('#emailExtraFields').find('.email-fields-labels.specialEvents').removeClass('field_hidden');
			$('#emailExtraFields').find('.email-fields-labels.webcast').addClass('field_hidden');
			if (isSymposium) {
				$('.fetch-model.rdv').addClass('field_hidden');
				$('.fetch-model.symposium').removeClass('field_hidden');
			} else if (isRDV) {
				$('.fetch-model.symposium').addClass('field_hidden');
				$('.fetch-model.rdv').removeClass('field_hidden');
			}
		} else {
			if (attendType === 'person') {
				$('#emailExtraFields').addClass('field_hidden');
			}
			$('#emailExtraFields').find('.email-fields-labels.specialEvents').addClass('field_hidden');
			$('#emailExtraFields').find('.email-fields-labels.webcast').removeClass('field_hidden');
		}
	}

	function updateField3(e) {
		field3.val(`FR=~=${frNote.value}===EN=~=${enNote.value}`);
	}

	function toggleLinkedEventPrices() {
		var select = $(this);
		var activityType = $('.activity-type').val();
		var isSpecialEvent = activityType === '5' || activityType === '6';

		if (select.val() === 'hybrid') {
			$('#linkedEventPrices').removeClass('field_hidden');
			$('#linkedEventPrices').find('.derequired').removeClass('derequired').addClass('required');
			$('#emailExtraFields').removeClass('field_hidden');
			$('#duplicateWithLinkedEvent').prop('checked', true);
		} else {
			$('#linkedEventPrices').addClass('field_hidden');
			$('#linkedEventPrices').find('.required').removeClass('required').addClass('derequired');
			$('#duplicateWithLinkedEvent').prop('checked', false);
			if (!isSpecialEvent) {
				$('#emailExtraFields').addClass('field_hidden');
			}
		}
		if (select.val() === 'webcast') {
			$('.eventMainType').val('webcast');
			$('#emailExtraFields').removeClass('field_hidden');
		} else if (select.val() === 'person') {
			$('.eventMainType').val('person');
		}

		$('.linked-event-header').hide();
		if ($('.eventMainType').val() === 'person') {
			$('.linked-event-header_webcast').show();
		} else {
			$('.linked-event-header_person').show();
		}
	}

	function addInclusionExclusion({currentTarget}) {
		let type = currentTarget.id.indexOf('inclusion') > -1 ? 'inclusion' : 'exclusion';
		let $ctn = $(currentTarget.dataset.ctn);
		let $clone = $ctn.find('.clone').clone(true, true);
		let temporaryRandomId = (Math.random() * 100000) | 1;

		$clone.removeClass('clone');
		$clone.find('input, textarea, label').each((i, el) =>{
			if (el.tagName === 'LABEL') {
				el.setAttribute("for", el.getAttribute("for") + temporaryRandomId);
			} else {
				el.name = el.name + temporaryRandomId;
				el.id = el.id + temporaryRandomId;
			}
		});
		$ctn.append($clone);
	}

	function deleteInclusionExclusion({currentTarget}) {
		let {type} = currentTarget.dataset
		$(currentTarget).closest('.event-admin-inclusion-exclusion').remove();
		
		if (type === 'inclusion') {
			buildField1();
		} else {
			buildField2();
		}
	}

	function buildField1() {
		buildField(field1, 'inclusion');
	}

	function buildField2() {
		buildField(field2, 'exclusion');
	}

	function buildField($field, type) {
		let $ctn = $(`#event-${type}s`);
		let $elements = $ctn.find('.event-admin-inclusion-exclusion:not(.clone)');
		let fr = [];
		let en = [];

		$elements.each((i, el) => {
			let frTitle = el.querySelector(`input[name^="${type}-title-fr-"]`).value;
			let frDesc = el.querySelector(`textarea[name^="${type}-desc-fr-"]`).value;
			let enTitle = el.querySelector(`input[name^="${type}-title-en-"]`).value;
			let enDesc = el.querySelector(`textarea[name^="${type}-desc-en-"]`).value;

			fr.push(`${frTitle}~=~${frDesc}`);
			en.push(`${enTitle}~=~${enDesc}`);
		});

		$field.val(`FR=~=${fr.join("~-~")}===EN=~=${en.join("~-~")}`);
	}
    
    function fetchModel(){
        var t = $(this);
        var key = t.attr("data-key");
        var textarea = t.attr("data-text");
        
        ajax('/action/getLabel?site=true&key=' + key, function(resp){
            tinyMCE.get(textarea).setContent(resp);
        }, true);
    }

	$(init);

})(jQuery);